<template>
  <v-card
    v-if="
      Object.keys(getField('metadata')).includes(
        'data_processes_and_conditions',
      ) && getField('metadata').data_processes_and_conditions.length
    "
    class="pa-4 mt-15 d-flex flex-column overflow-initial"
    border
    :color="backColor"
    tile
    elevation="3"
  >
    <Icon item="maintains" size="20" class="pt-2" />
    <v-card-title class="pa-0 text--primary card-title-customize">
      Processes
    </v-card-title>
    <!--  Container  -->
    <div
      v-for="(item, key, index) in generateProcessesData()"
      :key="key + '_' + index"
      class="mt-0 pt-8 d-flex flex-column"
    >
      <div
        v-for="(subItem, subIndex) in item.data"
        :key="subItem.name + '_' + subIndex"
      >
        <div
          class="content-wrapper pa-4 mt-4 d-flex flex-row justify-space-between full-width"
          :class="{ 'flex-column': $vuetify.display.xs }"
        >
          <!--  Name, Access Method, URL    -->
          <div class="full-width min-width-200 max-width-500">
            <!--  Name    -->
            <div
              v-if="subItem.name"
              class="d-flex flex-row align-center min-height-40"
            >
              <b class="width-200">Name</b>
              <div class="d-flex full-width ml-md-12 ml-13">
                <a class="underline-effect" :href="subItem.url" target="_blank">
                  {{ subItem.name }}
                </a>
              </div>
            </div>

            <!--  AccessMethod   -->
            <div
              v-if="subItem.access_method"
              class="d-flex flex-row align-center min-height-40"
            >
              <b class="width-200">Access Method</b>
              <div class="d-flex full-width ml-md-12 ml-13">
                {{ subItem.access_method }}
              </div>
            </div>
            <!--  Example URL    -->
            <div
              v-if="subItem.example_url"
              class="d-flex flex-row align-stretch min-height-40"
            >
              <b class="width-200">Example URL</b>
              <div class="d-flex full-width ml-md-12 ml-13">
                <a
                  class="underline-effect word-break"
                  :href="subItem.example_url"
                  target="_blank"
                >
                  {{ truncate(subItem.example_url, 100) }}
                </a>
              </div>
            </div>
            <!-- Documentation URL    -->
            <div
              v-if="subItem.documentation_url"
              class="d-flex flex-row align-stretch min-height-40"
            >
              <b class="width-200">Documentation URL </b>
              <div class="d-flex full-width ml-md-12 ml-13">
                <a
                  class="underline-effect word-break"
                  :href="subItem.documentation_url"
                  target="_blank"
                >
                  {{ truncate(subItem.documentation_url, 100) }}
                </a>
              </div>
            </div>
          </div>
          <!--  Type    -->
          <div
            v-if="subItem.type"
            class="d-flex flex-row align-top min-height-40 justify-end"
            :class="{ 'flex-column': $vuetify.display.xs }"
          >
            <div
              class="d-flex flex-row full-width ml-md-12"
              :class="{ 'flex-column': $vuetify.display.smAndUp }"
            >
              <b class="width-100" :class="{ 'mr-8': $vuetify.display.xs }"
                >Read</b
              >

              <span v-if="subItem.type === 'read'">
                <v-icon size="medium"> fas fa-check </v-icon> </span
              ><span v-else-if="subItem.type === 'read and write'">
                <v-icon size="medium"> fas fa-check </v-icon>
              </span>
            </div>
            <div
              class="d-flex flex-row full-width ml-md-12"
              :class="{ 'flex-column': $vuetify.display.smAndUp }"
            >
              <b :class="{ 'width-100 mr-8': $vuetify.display.xs }">Write</b>
              <span v-if="subItem.type === 'write'">
                <v-icon size="medium"> fas fa-check </v-icon> </span
              ><span v-else-if="subItem.type === 'read and write'">
                <v-icon size="medium"> fas fa-check </v-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

import Icon from "@/components/Icon";
import clearString from "@/utils/stringUtils";
import truncate from "@/utils/stringUtils";

export default {
  name: "DataProcessAndCondition",
  components: {
    Icon,
  },
  mixins: [clearString, truncate],
  props: {
    backColor: {
      default: null,
      type: String,
    },
  },
  data: () => {
    return {
      processedDataConditions: {},
      finalData: {},
    };
  },
  computed: {
    ...mapGetters("record", ["getField"]),
  },
  methods: {
    generateProcessesData() {
      let processedDataConditions = {};
      const data_processes_and_conditions =
        this.getField("metadata")["data_processes_and_conditions"];
      // initializing object's key and data dynamically based on any number of types coming from API
      if (data_processes_and_conditions) {
        data_processes_and_conditions.forEach((item) => {
          if (
            !Object.prototype.hasOwnProperty.call(
              this.processedDataConditions,
              item.type,
            )
          ) {
            processedDataConditions[item.type] = {
              data: [],
              icon: null,
            };
          }
        });
        // assigning data and icon to the different types came from API.
        data_processes_and_conditions.forEach((item) => {
          processedDataConditions[item.type].icon = item.type.replace(
            /\s/g,
            "_",
          );
          processedDataConditions[item.type].data.push(item);
        });
      }
      return processedDataConditions;
    },
  },
};
</script>

<style scoped>
.content-wrapper {
  border: 1px lightgrey solid;
}
</style>
